export default "__VITE_ASSET__2a806ac9__"